export type TemplateTabId = 'details' | 'draft' | 'versions';

export interface TemplateTab {
  id: TemplateTabId;
  label: string;
}

const DETAILS_TAB: TemplateTab = { id: 'details', label: 'Details' };
const DRAFT_TAB: TemplateTab = { id: 'draft', label: 'Draft' };
const VERSIONS_TAB: TemplateTab = { id: 'versions', label: 'Versions' };

export const templateTabs = (canManage: boolean): TemplateTab[] =>
  canManage ? [DETAILS_TAB, DRAFT_TAB, VERSIONS_TAB] : [DETAILS_TAB, VERSIONS_TAB];

/** The tab named by the URL segment, or null when it is unknown or not available to this user. */
export function resolveTemplateTab(segment: string | undefined, canManage: boolean): TemplateTabId | null {
  if (segment === undefined) return 'details';
  return templateTabs(canManage).find((tab) => tab.id === segment)?.id ?? null;
}

export const templateTabPath = (templateId: string, tab: TemplateTabId): string =>
  tab === 'details' ? `/admin/document-templates/${templateId}` : `/admin/document-templates/${templateId}/${tab}`;
